const useEntrySummaryData = (formData) => {
    const { orgEntryNumber, orgFillerCode, orgRevenueDetails: {DUTY:{revenueAmount:orgDuty=""}={}, "HARBOR MAINTENANCE FEE":{revenueAmount:orgHmf=""}={}, "FORMAL MERCHANDISE PROCESSING FEE":{revenueAmount:orgMpf=""}={}}={}, reconRevenueDetails:{DUTY:{revenueAmount:reconDuty=""}={}, "HARBOR MAINTENANCE FEE":{revenueAmount:reconHmf=""}={}, "FORMAL MERCHANDISE PROCESSING FEE":{revenueAmount:reconMpf=""}={}}, lineItemList, reconciledEntryId} = formData;
    const entrySummaryData = [
        {
            label: "Entry Number",
            name: "orgEntryNumber",
            id: "orgEntryNumber",
            value: orgFillerCode + orgEntryNumber,
            isDisabled: true
        },
        {
            label: "Entry Summary Line Total",
            name: "lineItemList",
            id: "lineItemList",
            value: lineItemList.length,
            isDisabled: true
        },
        {
            label: "Original Duty Total",
            name: "orgRevenueDetails.DUTY.revenueAmount",
            id: "orgDuty",
            value: orgDuty,
            onChange: (e) => console.log("hahahahaha overriden onChange")
        },
        {
            label: "Reconciled Duty Total",
            name: "reconRevenueDetails['DUTY'].revenueAmount",
            id: "reconDuty",
            value: reconDuty
        },
        {
            label: "Original MPF Total",
            name: "orgRevenueDetails['FORMAL MERCHANDISE PROCESSING FEE'].revenueAmount",
            id: "orgMpf",
            value: orgMpf
        },
        {
            label: "Reconciled MPF Total",
            name: "reconRevenueDetails['FORMAL MERCHANDISE PROCESSING FEE'].revenueAmount",
            id: "reconMpf",
            value: reconMpf
        },
        {
            label: "Original HMF Total",
            name: "orgRevenueDetails['HARBOR MAINTENANCE FEE'].revenueAmount",
            id: "orgHmf",
            value: orgHmf
        },
        {
            label: "Reconciled HMF Total",
            name: "reconRevenueDetails['HARBOR MAINTENANCE FEE'].revenueAmount",
            id: "reconHmf",
            value: reconHmf
        },
    ]
    return entrySummaryData;
}
 
export default useEntrySummaryData;